
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskflowStatus } from 'enums/TaskflowStatus';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { CompanyModel } from './Entities.GormCrm.Company';
import { OrderWarningModel } from './Entities.GormCrm.OrderWarning';
import { QuestionnaireQuestionReplyModel } from './Entities.GormCrm.QuestionnaireQuestionReply';
import { TaskflowTemplateModel } from './Entities.GormCrm.TaskflowTemplate';
import { TaskActionModel } from './Entities.GormCrm.TaskAction';
import { TaskAttachmentModel } from './Entities.GormCrm.TaskAttachment';
import { Model, ModelProperty } from 'models/Model';


export class TaskflowModel extends Model<TaskflowModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'subTaskflows', type: 'TaskflowModel[]', languageString: 'taskflow.property.subTaskflows', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } },
		{ name: 'status', type: 'TaskflowStatus', languageString: 'taskflow.property.status' },
		{ name: 'productPlans', type: 'ProductPlanModel[]', languageString: 'taskflow.property.productPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'id', type: 'guid', languageString: 'taskflow.property.id', isHidden: true },
		{ name: 'companyId', type: 'guid', languageString: 'taskflow.property.companyId' },
		{ name: 'title', type: 'string', languageString: 'taskflow.property.title' },
		{ name: 'description', type: 'string', languageString: 'taskflow.property.description' },
		{ name: 'created', type: 'Date', languageString: 'taskflow.property.created', isHidden: true },
		{ name: 'deadline', type: 'Date', languageString: 'taskflow.property.deadline' },
		{ name: 'sourceTemplateId', type: 'guid', languageString: 'taskflow.property.sourceTemplateId' },
		{ name: 'owner', type: 'guid', languageString: 'taskflow.property.owner' },
		{ name: 'createdById', type: 'guid', languageString: 'taskflow.property.createdById' },
		{ name: 'currentStep', type: 'number', languageString: 'taskflow.property.currentStep' },
		{ name: 'parentTaskflowId', type: 'guid', languageString: 'taskflow.property.parentTaskflowId' },
		{ name: 'stepOnParent', type: 'number', languageString: 'taskflow.property.stepOnParent' },
		{ name: 'completed', type: 'Date', languageString: 'taskflow.property.completed' },
		{ name: 'company', type: 'CompanyModel', languageString: 'taskflow.property.company', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'inverseParentTaskflow', type: 'TaskflowModel[]', languageString: 'taskflow.property.inverseParentTaskflow', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } },
		{ name: 'orderWarnings', type: 'OrderWarningModel[]', languageString: 'taskflow.property.orderWarnings', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderWarningModel }, properties: () => { return OrderWarningModel.classProperties } },
		{ name: 'parentTaskflow', type: 'TaskflowModel', languageString: 'taskflow.property.parentTaskflow', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } },
		{ name: 'questionnaireQuestionReplies', type: 'QuestionnaireQuestionReplyModel[]', languageString: 'taskflow.property.questionnaireQuestionReplies', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionReplyModel }, properties: () => { return QuestionnaireQuestionReplyModel.classProperties } },
		{ name: 'sourceTemplate', type: 'TaskflowTemplateModel', languageString: 'taskflow.property.sourceTemplate', isHidden: true, isObject: true, new: () => { return new TaskflowTemplateModel }, properties: () => { return TaskflowTemplateModel.classProperties } },
		{ name: 'taskActions', type: 'TaskActionModel[]', languageString: 'taskflow.property.taskActions', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskActionModel }, properties: () => { return TaskActionModel.classProperties } },
		{ name: 'taskAttachments', type: 'TaskAttachmentModel[]', languageString: 'taskflow.property.taskAttachments', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskAttachmentModel }, properties: () => { return TaskAttachmentModel.classProperties } }
	];
	[key: string]: any;
	
	public subTaskflows: TaskflowModel[];
	public status: TaskflowStatus;
	public productPlans: ProductPlanModel[];
	public id?: string;
	public companyId?: string;
	public title: string;
	public description: string;
	public created?: Date;
	public deadline?: Date;
	public sourceTemplateId?: string;
	public owner?: string;
	public createdById?: string;
	public currentStep: number;
	public parentTaskflowId?: string;
	public stepOnParent?: number;
	public completed?: Date;
	public company?: CompanyModel;
	public inverseParentTaskflow: TaskflowModel[];
	public orderWarnings: OrderWarningModel[];
	public parentTaskflow?: TaskflowModel;
	public questionnaireQuestionReplies: QuestionnaireQuestionReplyModel[];
	public sourceTemplate?: TaskflowTemplateModel;
	public taskActions: TaskActionModel[];
	public taskAttachments: TaskAttachmentModel[];
    
	constructor(){
		super();
		this.subTaskflows = [];
		this.status = 0;
		this.productPlans = [];
		this.id = undefined;
		this.companyId = undefined;
		this.title = '';
		this.description = '';
		this.created = undefined;
		this.deadline = undefined;
		this.sourceTemplateId = undefined;
		this.owner = undefined;
		this.createdById = undefined;
		this.currentStep = 0;
		this.parentTaskflowId = undefined;
		this.stepOnParent = undefined;
		this.completed = undefined;
		this.company = undefined;
		this.inverseParentTaskflow = [];
		this.orderWarnings = [];
		this.parentTaskflow = undefined;
		this.questionnaireQuestionReplies = [];
		this.sourceTemplate = undefined;
		this.taskActions = [];
		this.taskAttachments = [];
		
	}
	getProperties(){
		return TaskflowModel.classProperties;
	}
}

